import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Link as ScrollLink } from "react-scroll";
import Typical from "react-typical";

import content from "../../content";

export default function Header() {
  const [animated, setAnimated] = useState(false);
  useEffect(() => {
    setAnimated(true);
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center blue-primary-background"
      id="header"
    >
      <div className="w-10/12 mx-auto flex flex-col-reverse md:flex-row items-center justify-between mt-5">
        <div className="text-white font-dosis text-center md:text-left">
          <h2
            className={`${
              animated ? "" : "translate-y-10 opacity-0"
            }  transform transition duration-2000 ease-in-out text-3xl md:text-5xl font-bold`}
          >
            {content.header.text[0]}
            <br />
            {content.header.text[1]}
          </h2>
          <h1
            className={`${
              animated ? "" : "translate-y-10 opacity-0"
            }  transform transition duration-2000 ease-in-out font-bold text-2xl text-gray-500`}
          >
            {content.header.text[2]}{" "}
            <Typical
              steps={content.header.typical}
              loop={Infinity}
              className="inline-block mt-2"
            />
          </h1>
          <ScrollLink to="stack" smooth={true} duration={200} delay={10}>
            <button className="yellow-primary-background btn-hover font-bold px-10 py-3 text-xl uppercase mt-4 rounded-lg">
              {content.header.btnText}
            </button>
          </ScrollLink>
        </div>
        <div className="w-full md:w-2/5 animate-floatSlow">
          <LazyLoadImage
            src={content.header.img}
            effect="blur"
            delayTime="6000"
            placeholderSrc={
              process.env.PUBLIC_URL + "/assets/stack/react-logo.png"
            }
          />
        </div>
      </div>
    </div>
  );
}
